import { createSelector } from 'reselect';
import shuffle from 'lodash/shuffle';
import {
  selectInfoBarMarketingPlacements, selectInfoBarMarketingIsLoaded, selectInfoBarMarketingIsLoading,
} from 'core/modules/InfoBarMarketing/selectors';

export const selectLetterboxTOF = state => state.letterboxTOF;

export const selectLetterboxTOFConfig = createSelector(
  selectLetterboxTOF, letterboxTOF => letterboxTOF.config,
);

export const selectMarketingContent = createSelector(
  selectLetterboxTOF, letterboxTOF => letterboxTOF.marketingContent,
);

export const selectMerchantContent = createSelector(
  selectLetterboxTOF, letterboxTOF => letterboxTOF.merchantContent,
);

export const selectMarketingContentPlacements = createSelector(
  selectMarketingContent, marketingContent => marketingContent.placements,
);

export const selectMerchantContentPlacements = createSelector(
  selectMerchantContent, merchantContent => merchantContent.placements,
);

// Check if Marketing Info Bar, Merchant Dependent and
// Merchant Independent placements are loaded in case marketing content is enabled
export const selectLetterboxTOFIsLoaded = createSelector([
  selectInfoBarMarketingIsLoaded, selectMarketingContent, selectMerchantContent,
  (state, letterboxCategoryId) => letterboxCategoryId,
], (infoBarMarketingIsLoaded, marketingContent, merchantContent, letterboxCategoryId) => (
  (letterboxCategoryId ? true : infoBarMarketingIsLoaded) && merchantContent.isLoaded &&
  (marketingContent.config.isEnabled ? marketingContent.isLoaded : true)
));

// Check if Marketing Info Bar, Merchant Dependent and
// Merchant Independent placements are loading in case marketing content is enabled
export const selectLetterboxTOFIsLoading = createSelector([
  selectInfoBarMarketingIsLoading, selectMarketingContent, selectMerchantContent,
], (infoBarMarketingIsLoading, marketingContent, merchantContent) => (
  infoBarMarketingIsLoading && merchantContent.isLoading &&
    (marketingContent.config.isEnabled ? marketingContent.isLoading : true)
));

// CLPL-4627: Marketing Info Bar content should be the primary letterbox slot for mobile and tablet
export const selectLetterboxTOFPlacements = createSelector([
  selectInfoBarMarketingPlacements, selectMarketingContentPlacements, selectMerchantContentPlacements,
], (infoBarMarketingPlacements, marketingContentPlacements, merchantContentPlacements) => {
  const markentingAndMerchantPlacements = shuffle([...marketingContentPlacements, ...merchantContentPlacements]);

  return [...infoBarMarketingPlacements.slice(0, 1), ...markentingAndMerchantPlacements];
});
